module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-08.ded71b0d.png";